import { Link } from "@tanstack/react-router";
import { useT } from "@/i18n";

export function NotFound() {
  const { t } = useT();
  return (
    <section className="px-pad-x py-pad-y">
      <h1 className="text-fs6 font-semibold text-ink-1">{t("state.notFound.title")}</h1>
      {/* THE APP'S ONE LINK, AND ITS STYLE LIVES HERE UNTIL THERE ARE TWO.
          `brand-ink` on paper, ALWAYS UNDERLINED — not underlined on hover. A
          link told apart from the text round it by colour alone is invisible to
          anyone who cannot see the colour, and `hover:` is no help at all to
          somebody arriving on the keyboard. A second link promotes this to a
          `link` variant in `ui/button`; it is not one now because that module
          carries tailwind-merge, which this path does not. */}
      <Link to="/" className="mt-s3 inline-block text-fs3 text-brand-ink underline underline-offset-4">
        {t("state.notFound.action")}
      </Link>
    </section>
  );
}
